import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import createRef from 'create-react-ref/lib/createRef';

import Breadcrumb from './BreadcrumbComponent';

import './Breadcrumbs.scss';

class Breadcrumbs extends React.Component {
  static arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i += 1) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  static calcLineStarters(lineWidth, itemSizeList) {
    const starterIndexes = [];

    let sum = 0;
    itemSizeList.forEach((size, index) => {
      sum += size;
      if (sum > lineWidth) {
        starterIndexes.push(index);
        sum = size;
      }
    });

    return starterIndexes;
  }

  constructor(props) {
    super(props);
    this.state = {
      starterItemsList: [],
    };
    // TODO: use native createRef after upgrading to React 16.3+
    this.breadcrumbsRef = createRef();
  }

  componentDidMount() {
    this.restyleBreadcrumbs(this.breadcrumbsRef.current);
    window.addEventListener('resize', () => this.forceUpdate());
  }

  componentDidUpdate() {
    this.restyleBreadcrumbs(this.breadcrumbsRef.current);
  }

  breadcrumbsSize() {
    if (this.breadcrumbsRef && this.breadcrumbsRef.current) {
      return this.breadcrumbsRef.current.offsetWidth;
    }
    return 0;
  }

  restyleBreadcrumbs(crumb) {
    if (!crumb) return;
    const listWidth = this.breadcrumbsSize();
    const nrOfChildren = crumb.children.length;
    const listItemsWidth = [];

    for (let i = 0; i < nrOfChildren; i += 1) {
      listItemsWidth.push(crumb.children[i].getBoundingClientRect().width);
    }

    const starterIndexes = this.constructor.calcLineStarters(listWidth, listItemsWidth);

    if (!this.constructor.arraysEqual(this.state.starterItemsList, starterIndexes)) {
      this.setState({
        starterItemsList: starterIndexes,
      });
    }
  }

  render() {
    const breadcrumbsList = this.props.items.map((item, index) => {
      const key = item.name.replace(/\s/g, '') + index;
      return (
        <Breadcrumb
          key={key}
          className={this.state.starterItemsList.includes(index) ? 'new-line-separator' : ''}
          url={item.url}
          name={item.name}
        />
      );
    });

    const className = classNames('breadcrumbs', 'list-bare u-display-flex u-flexWrap-wrap');

    return (
      <ul className={className} ref={this.breadcrumbsRef}>
        {breadcrumbsList}
      </ul>
    );
  }
}

Breadcrumbs.displayName = 'Breadcrumbs';

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
};

export default Breadcrumbs;
